import Model from './Model';
import {
    DOCUMENT_TEMPLATE_TAG_TYPE_CHOICE,
    DOCUMENT_TEMPLATE_TAG_TYPE_STRING
} from '@/store/modules/document-template-tags';
import _ from 'lodash';

export default class DocumentTemplate extends Model {
    name = '';
    requires_approval = false;
    contents = '';
    fields = [];

    static apiPath() {
        return 'document-templates';
    }

    toJson() {
        return {
            ...super.toJson(),
            fields: this.fields.map(field => ({
                ...field,
                configuration: DocumentTemplate.serializeFieldConfig(field),
            })),
        };
    }

    fill(json) {
        super.fill(json);
        if (json.fields) {
            this.fields = json.fields.map(field => ({
                ...field,
                configuration: DocumentTemplate.parseFieldConfig(field),
            }));
        }
    }

    static serializeFieldConfig(field) {
        switch (field.type) {
        case DOCUMENT_TEMPLATE_TAG_TYPE_STRING: {
            return JSON.stringify(field.configuration || null);
        }
        case DOCUMENT_TEMPLATE_TAG_TYPE_CHOICE: {
            const options = !field.configuration ? null : _.chain(field.configuration)
                .keyBy('id')
                .mapValues('text')
                .value();
            return JSON.stringify(options);
        }
        }
    }

    static parseFieldConfig(field) {
        switch (field.type) {
        case DOCUMENT_TEMPLATE_TAG_TYPE_STRING: {
            return field.configuration ? JSON.parse(field.configuration) : null;
        }
        case DOCUMENT_TEMPLATE_TAG_TYPE_CHOICE: {
            if (!field.configuration) return [];
            const parsed = JSON.parse(field.configuration);
            return _.map(parsed, (text, id) => ({id, text}));
        }
        }
    }
}

export const NEW_TEMPLATE_TEXT = `
<h1>Elementen</h1>
<p>
Gebruik de <strong>knoppen</strong> om de <strong>opmaak</strong> van het document te <strong>wijzigen</strong>.
</p>
<h2>Lijstjes</h2>
<p>
Om een genummerde lijst te maken typ "<code>1. </code>" om een lijst te beginnen.
Vervolgens voegt ieder nieuwe lijn een extra punt in.
Om de lijst te beëindigen druk tweemaal op enter.
</p>
<ol>
    <li>Eerste punt</li>
    <li>Tweede punt</li>
    <li>Derde punt</li>
</ol>
<p>
Om een lijst zonder nummers in te voeren begin de lijst met "<code>* </code>".
Dezelfde regels gelden voor het invoeren van nieuwe regels tekst.
</p>
<ul>
    <li>Brood</li>
    <li>Boter</li>
    <li>Bananen</li>
</ul>
<h2>Tabellen</h2>
<table>
<tr>
<td colspan="3">Dit is een tabel, dit zijn 3 samengevoegde cellen.</td>
</tr>
<tr>
<td><strong>Naam</strong></td>
<td><span>[client-naam]</span></td>
<td><span>[client-email]</span></td>
</tr>
<tr>
<td><strong>Begeleider</strong></td>
<td><span>[adviseur-naam]</span></td>
<td><span>[adviseur-email]</span></td>
</tr>
<tr>
<td colspan="2">Je kan de kolom verdeling zelf uitlijnen door de scheidingslijnen te verslepen.</td>
<td>Je kan hiermee ook de breedte van de tabel aanpassen.</td>
</tr>
</table>
<h1>Velden</h1>
<p>
Document sjablonen ondersteunen het invoegen van velden die later door de gebruiker ingevuld kunnen worden.
Een voorbeeld van een veld is: <span>[client-naam]</span>.
Op deze manier hoeven gebruikers zelf niet de documenten te bewerken maar is het voor hun enkel een kwestie van een formulier invullen.
Er zijn 3 soorten velden: <em>standaard velden</em>, <em>invoer velden</em> en <em>lijst velden</em>. Onder het document paneel zijn panelen aanwezig om deze velden te beheren en in te vullen.
</p>
<h2>Standaard veld</h2>
<p>
Een standaard veld is een veld die door het systeem aangeboden wordt en gevuld wordt met informatie uit het systeem.
Een voorbeeld hiervan is de mogelijkheid om de naam van de klant, traject en organisatie in te laten vullen.
Het is niet mogelijk hier zelf nieuwe velden aan toe te voegen.
</p>
<h2>Invoer veld</h2>
<p>
Een invoer veld is een veld wat je zelf kan bedenken en wordt tijdens het gebruiken van het sjabloon door de gebruiker ingevuld.
Het paneel voor invoer velden bestaat uit een klein formulier om nieuwe velden toe te voegen en een lijst met de gemaakte velden.
</p>
<h2>Lijst velden</h2>
<p>
Een lijst veld is een variatie op een invoer veld waar je een meerkeuze lijst van opties meegeeft aan de gebruiker.
De gebruiker die het sjabloon gaat gebruiken kan tijdens het invullen dan een of meerdere van de door jouw opgegeven opties kiezen en deze zullen in het document verscheinen (gescheiden met een komma).
</p>
<p><strong>Zelfgemaakte velden mogen enkel bestaan uit kleine letters, nummers en '-'. Plus iedere veldnaam moet uniek zijn binnen het sjabloon.</strong></p>
<h2>Velden invoegen in document</h2>
<p>
Behalve velden invoegen door op ze te klikken in de veld panelen kunnen ze ook worden toegevoegd door ze in te typen met de juiste begin en eind tekens.
Het document paneel heeft een ingebouwde suggestie functie die helpt bij het toevoegen van een veld in het document. Het suggestie paneel verschijnt automatisch wanneer een '[' getypt wordt. Vervolgens kan een woord getypt worden en zal er door de beschikbare set van velden gezocht worden.
Een suggestie kan op twee manieren ingevoegd worden. Als eerste kan je met de muis op een van de suggesties klikken om je huidige invoer te vervangen met het gewenste veld.
Je kan ook met de omhoog en omlaag pijltjes toetsen de suggesties navigeren en met de <code>enter</code> toets of de <code>]</code> toets de geselecteerde suggestie invoegen.
</p>
`;



// WEBPACK FOOTER //
// ./src/models/DocumentTemplate.js